export default "__VITE_ASSET__CRnemO8C__"